<template>
  <div v-if="initDataComplete" id="app" @wheel.prevent="onWheel" :class="lang">
    <Aside/>
    <Navi/>
<!--    <Intro v-if="isIntro" class=""/>-->
    <div v-show="initLoadComplete" class="container">
      <router-view :key="$route.fullPath" v-if="!isMobile"/>
      <router-view :key="$route.fullPath" v-else name="mobile" />
    </div>
    <transition leave-active-class="clip-layer-leave">
      <ClipLayer v-if="selectClip" :selectData="selectClip" @hideLayer="hideLayer"></ClipLayer>
    </transition>
    <Loader/>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {mapState, mapGetters, mapMutations} from 'vuex'
  import '@/utils/ResizeEvent'
  import Navi from '@/components/Navi';
  import Aside from '@/components/Aside';
  import Loader from '@/components/Loader';
  import ClipLayer from '@/components/ClipLayer';
  import Intro from '@/views/Intro';

  import promokit from '@/utils/promokit';
  import routerControll from "@/utils/routerControll";


  import 'slick-carousel';
  import "slick-carousel/slick/slick.css";

  export default {
    data() {
      return {
        routes: this.$router.options.routes,
        isDrag:false,
        isMobile:promokit.util.isMobile(),
        wheelPow:0,
        wheelTimer:null,
        isWheel:false
      };
    },
    components: {
      Navi,
      Aside,
      Loader,
      Intro,
      ClipLayer
    },
    computed: {
      ...mapState([
        'lang',
        'initDataComplete',
        'initLoadComplete',
        'isMovePage',
        'selectClip',
        'isLayer'
      ]),
      ...mapGetters([
        'getDragPos'
      ])
    },
    methods: {
      ...mapMutations([
        'setLang',
        'setCountry',
        'setLocale',
        'setDragPos',
        'setPageMoveType',
        'setSelectClip',
        'setIsLayer',
        'setAdkey'
      ]),
      onWheel(e) {
        if (this.isMovePage) return;
        if(document.querySelector('.nav').classList.contains('active'))return;
        if(e.deltaY<0){
          if($(document).scrollTop() > 0){
            e.preventDefault()
            $(document).scrollTop($(document).scrollTop()+e.deltaY);
            return;
          }
        }
        if(e.deltaY>0){
          if($(document).scrollTop()+ $(window).height() < $(document).height()){
            e.preventDefault()
            $(document).scrollTop($(document).scrollTop()+e.deltaY);
            return;
          }
        }
        if(this.isLayer) return;
        this.wheelPow += e.deltaY/3;
        if(e.deltaY<0 && this.$router.currentRoute.name == 'index')return;
        if(e.deltaY>0 && this.$router.currentRoute.name == this.routes[this.routes.length-2].name)return;

        if(Math.abs(this.wheelPow) > 75){
          this.isWheel = false;
          this.setPageMoveType('wheel')
          this.setDragPos({
            isWheel:false,
            s:{y:0},
            d:{y:this.wheelPow}
          })
          if(this.wheelPow > 0){
            routerControll('next');
          }else{
            routerControll('prev');
          }
          this.wheelPow = 0;
          clearTimeout(this.wheelTimer);
          this.wheelTimer = null;
        }else{
          this.isWheel = true;
          this.setDragPos({
            isWheel:true,
            s:{y:0},
            d:{y:this.wheelPow}
          })
          clearTimeout(this.wheelTimer);
          this.wheelTimer = setTimeout(()=>{
            this.isWheel = false;
            this.wheelPow = 0;
            this.setDragPos({
              isWheel:false,
              s:{y:0},
              d:{y:this.wheelPow}
            })
          }, 500)
        }
      },

      dragStart(e) {
        const x = e.clientX ? e.clientX : e.touches[0].clientX;
        const y = e.clientY ? e.clientY : e.touches[0].clientY;
        this.setDragPos({
          isDrag:true,
          c:true,
          s:{x,y},
          d:{x,y}
        })
        this.isDrag = true;
      },
      drag(e) {
        if(this.isMobile){
          if(!this.isDrag)return;
        }
        if(this.isWheel)return;
        if(e.clientX <= 0)return;

        const x = e.clientX ? e.clientX : e.touches[0].clientX;
        const y = e.clientY ? e.clientY : e.touches[0].clientY;

        if(this.isMobile){
        const scrollPow = this.getDragPos.s.y- y;


        if(Math.abs(scrollPow) > 120){
          this.setPageMoveType('drag')
          this.isDrag = false;
          if(scrollPow > 0){
            routerControll('next');
          }else{
            routerControll('prev');
          }
        }
        }
        this.setDragPos({
          c:false,
          d:{x,y}
        })



      },
      dragEnd(e) {
        this.isDrag = false;this.setDragPos({
          isDrag:false
        })
      },

      hideLayer(){
        this.setSelectClip(null);
        this.setIsLayer(false)

      },
    },
    created() {
      this.setLang(document.querySelector('html').getAttribute('lang'));
      this.setCountry(document.querySelector('html').dataset.country);
      this.setLocale(document.querySelector('html').dataset.locale);
      this.$store.dispatch('initData');

      this.$i18n.locale = this.lang;
      if(window.location.search != ''){
        this.setAdkey(window.location.search)
        this.$cookies.set('adkey', window.location.search, '1d');
      }else{
        if(this.$cookies.get('adkey')){
          this.setAdkey(this.$cookies.get('adkey'))
        }
      }
    },
    mounted() {

      document.querySelector('body').classList.add(this.lang)
      this.$watch('initDataComplete', (val) => {
        if(!val)return;
        // if(promokit.util.isMobile()){
        this.$el.addEventListener("mousedown", this.dragStart);
        this.$el.addEventListener("touchstart", this.dragStart);
        this.$el.addEventListener("mousemove", this.drag);
        this.$el.addEventListener("touchmove", this.drag);
        this.$el.addEventListener("mouseup", this.dragEnd);
        this.$el.addEventListener("touchend", this.dragEnd);
        this.$el.addEventListener("mouseleave", this.dragEnd);
        // }else{
        //   this.isDrag = true;
        //   this.$el.addEventListener("mousemove", this.drag);
        // }
      }, {immediate:true})
    }
  }
</script>

<style lang="scss">
  /* hebrew */
  @font-face {
    font-family: 'LineageWIdentity';
    font-style: normal;
    font-weight: 400;
    src: url(./assets/fonts/LineageWIdentitytest21.woff2) format('woff2'),
    url(./assets/fonts/LineageWIdentitytest21.woff) format('woff'),
    url(./assets/fonts/LineageWIdentitytest21.ttf) format('truetype');;
  }

  .clip-layer-leave{
    opacity: 0;
    transform: scale(0.9);
    transition: 0.3s;
  }
</style>


